export default "__VITE_ASSET__hYL7Rtl8BrtKh60VrtjM$A__"